<script setup lang="ts">
import { ref } from "vue";
import JustificationModal from "@/components/v2/Modal/JustificationModal.vue";
import EquipmentConfigurations from "./EquipmentConfigurations.vue";
import EquipmentTemplates from "./EquipmentTemplates.vue";
import EquipmentHistory from "./EquipmentHistory.vue";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";
import { useRouter } from "vue-router";

// ===================================================================
// State
// ===================================================================
const activeTab = ref('configurations'); // 'configurations', 'templates', or 'history'

// ===================================================================
// Composables
// ===================================================================
const router = useRouter();

// ===================================================================
// Actions
// ===================================================================
const switchTab = (tab: string) => {
  activeTab.value = tab;
};

const handleBack = () => {
  router.back();
}
</script>

<template>
  <div class="container mx-auto">
    <!-- Justification Modal -->
    <JustificationModal />

    <!-- Header and Tab Navigation -->
    <div class="flex items-center justify-between w-full mb-6">
      <h1 class="text-2xl font-semibold">Equipment Management</h1>
      <div class="flex items-center gap-2">
        <button
            @click="switchTab('configurations')"
            class="px-4 py-2 text-sm rounded-md"
            :class="activeTab === 'configurations' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'"
        >
          Configurations
        </button>
        <button
            @click="switchTab('templates')"
            class="px-4 py-2 text-sm rounded-md"
            :class="activeTab === 'templates' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'"
        >
          Add New
        </button>
        <button
            @click="switchTab('history')"
            class="px-4 py-2 text-sm rounded-md"
            :class="activeTab === 'history' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'"
        >
          History
        </button>
        <button
            @click="handleBack"
            class="text-gray-600 hover:text-gray-800 flex items-center gap-1 text-sm"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          Back
        </button>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow p-6">
      <!-- Content based on selected tab -->
      <EquipmentConfigurations v-if="activeTab === 'configurations'" />
      <EquipmentTemplates v-else-if="activeTab === 'templates'" />
      <EquipmentHistory v-else-if="activeTab === 'history'" />
    </div>

    <FooterActions>
      <template #middle>
        <button
            @click="handleBack"
            class="w-full">
          Back
        </button>
      </template>
    </FooterActions>
  </div>
</template>